/**
 * Created by PULSARINARA\d.monfort on 20/12/21.
 */

(function ($) {

})(jQuery);
